<template>
  <div class="container-payments mt-5">
    <b-row
      v-if="forpayMandate"
      style="width: 100%"
      class="content-card"
      no-gutters
    >
      <b-col md="12">
        <h3 class="text-customer text-center mb-5">
          Ya estas afiliado a Forpay
        </h3>
      </b-col>
      <b-col md="3" class="d-none d-md-block">
        <b-card-img
          :src="require('@/assets/images/card.png')"
          alt="Image"
          class="rounded-0"
          style="opacity: 0.9"
        ></b-card-img>
      </b-col>
      <b-col md="7">
        <b-card-body title="Detalle de tu mandato">
          <b-card-text>
            <b-table-simple>
              <tr>
                <th>Tipo</th>
                <td>
                  {{ getMandateType(forpayMandate.forpay_mandate_type) }}
                </td>
              </tr>
              <tr>
                <th>Medio</th>
                <td>
                  {{ getMandateMedium(forpayMandate.forpay_mandate_number) }}
                </td>
              </tr>
              <tr v-if="forpayMandate.forpay_mandate_type == 'CREDIT'">
                <th>Número</th>
                <td>
                  {{ getMandateNumber(forpayMandate.forpay_mandate_number) }}
                </td>
              </tr>
            </b-table-simple>
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
    <b-row v-else style="width: 100%" class="content-card" no-gutters>
      <b-col md="7" class="px-0 text-center">
        <h3 class="text-customer">
          ¡Olvidate de pagar tus cuotas aprovechando el pago automático!
        </h3>
        <b-card-img
          :src="require('@/assets/images/working.png')"
          alt="Image"
          class="rounded-0 my-4"
          style="width: 70%"
        ></b-card-img>
        <h5>
          Con Forpay puedes olvidarte de pagar tus cuotas mes a mes asignando a
          tu cuenta corriente o a la tarjeta de crédito que prefieras.
        </h5>
      </b-col>
      <b-col class="px-0">
        <b-overlay :show="loading" rounded="lg" spinner-variant="gold">
          <b-card
            no-body
            class="overflow-hidden mt-4 p-4 select-card"
            style="max-width: 540px"
          >
            <b-row no-gutters>
              <b-col md="5">
                <b-card-img
                  :src="require('@/assets/images/card.png')"
                  alt="Image"
                  class="rounded-0"
                  style="opacity: 0.9"
                ></b-card-img>
              </b-col>
              <b-col md="7">
                <b-card-body
                  title="Conecta tu cuenta o tarjeta aquí"
                  align="center"
                >
                  <b-card-text>
                    <div class="text-center mt-4 mb-3">
                      <b-button
                        class="w-100"
                        block
                        squared
                        variant="success"
                        @click="add_forpay(contract_id)"
                        >Afiliarse a Forpay</b-button
                      >
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "paymentOptions",
  components: {},
  props: {
    asset_id: null,
    project_id: { default: null },
  },
  data() {
    return {
      showForpay: null,
      loading: false,
      forpayMandate: null,
    };
  },
  mounted() {
    this.getForpayMandates();
  },
  computed: {
    contract_id() {
      return this.$store.getters.getContractId == undefined
        ? null
        : this.$store.getters.getContractId;
    },
    gcVersion() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
  },
  methods: {
    checkForpay() {
      return true;
    },
    getForpayMandates() {
      let self = this;
      this.axios
        .get(`payments/get_forpay_mandates?contract_id=${this.contract_id}`)
        .then((result) => {
          self.forpayMandate = result.data;
          this.$store.commit("setForpayMandate", result.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    add_forpay(contract_id) {
      console.log(contract_id);
      this.loading = true;
      this.axios
        .post("payments/forpay", {
          contract_id: contract_id,
        })
        .then((result) => {
          let url_redirect = result.data.url;
          if (url_redirect == "") {
            this.$swal(
              "Oops",
              "hubo un error agregando tu pago, favor intentar más tarde if redirect",
              "error"
            );
            this.loading = false;
          } else {
            window.location.href = url_redirect;
          }
        })
        .catch(() => {
          this.$swal(
            "Oops",
            "hubo un error agregando tu pago, favor intentar más tarde 500",
            "error"
          );
          this.loading = false;
        });
    },
    getMandateType(type) {
      if (type == "CREDIT") return "Tarjeta de crédito";
      if (type == "DEBIT") return "Débito";
      return type;
    },
    getMandateNumber(number) {
      return "**** **** **** " + number.slice(-4);
    },
    getMandateMedium(medium) {
      return medium.split(" -")[0];
    },
  },
  watch: {
    contract_id: function (new_val) {
      if (new_val) this.getForpayMandates();
    },
  },
};
</script>
<style scoped>
.margin-10 {
  margin-top: 10;
}
</style>
